import styled from '@emotion/styled'
import { MultiButton } from 'view/components/buttons/MultiButton'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'

export const LockWrapper = styled.div`
  ${mixins.flexCenterContentCrossAxis}
  flex: 0 0 39px;
  height: 100%;
  margin-left: 5px;
`

export const LockIcon = styled.span`
  ${mixins.flexCenterContentCrossAxis};
  flex: 0 0 19px;
  padding: 0 5px;
`

export const LockButton = styled(MultiButton)<{ isLocked: boolean }>`
  ${mixins.flexCenterContentCrossAxis};
  height: 22px;

  ${LockIcon} {
    color: ${props => {
      return props.isLocked ? constants.ACCENT_PRIMARY : constants.CORE_PRIMARY_3
    }};

    &:hover {
      color: ${constants.ACCENT_PRIMARY_1};
    }
  }

  }
`

export const LockedUser = styled.span`
  ${mixins.flexCenterContentCrossAxis};
  flex: 0 0 20px;
`

export const EmptyLockRenderer = LockWrapper

export const IndicativeContainer = styled.span`
  display: flex;
  align-items: center;
  margin-left: 5px;
`
